import { Styles } from '@adaptive-web/adaptive-ui';
import { layerShapeStyles, plainTextStyles } from '@adaptive-web/adaptive-ui/reference';
import { AdaptiveDesignSystem, cardTemplateStyles, composeCard } from '@adaptive-web/adaptive-web-components';

export const customCardDefintion = composeCard(AdaptiveDesignSystem, {
	styleModules: [
		[
			{},
			Styles.compose(
				[
					layerShapeStyles,
					plainTextStyles
				]
			)
		]
	],
	styles: [
		cardTemplateStyles,
	]
});